// extracted by mini-css-extract-plugin
export default {"item":"ContactList_item__EZYHO","name":"ContactList_name__UCkFW","number":"ContactList_number__2af8f","text":"ContactList_text__+NWAW","textBox":"ContactList_textBox__+BYH9"};